import { useEffect, useRef } from 'react';
import { useLocation, useNavigation } from 'react-router';
import { useLoading } from '@/provider/LoadingProvider';
export function RouteLoadingGate() {
  const { show, hide } = useLoading();
  const nav = useNavigation();
  useEffect(() => {
    if (nav.state === 'loading' || nav.state === 'submitting') {
      show('Page loading…');
    } else {
      hide();
    }
  }, [nav.state, show, hide]);
  return null;
}
export function RouteLoadingGateClassic(props?: { minVisibleMs?: number; text?: string }) {
  const { minVisibleMs = 300, text = 'Page loading…' } = props || {};
  const { show, hide } = useLoading();
  const loc = useLocation();
  const lastHideAt = useRef<number>(0);
  useEffect(() => {
    show(text);
    const start = performance.now();
    const t = setTimeout(() => {
      const elapsed = performance.now() - start;
      const rest = Math.max(0, minVisibleMs - elapsed);
      const t2 = setTimeout(() => {
        hide();
        lastHideAt.current = performance.now();
      }, rest);
      return () => clearTimeout(t2);
    }, 0);
    return () => clearTimeout(t);
  }, [loc.pathname, show, hide, minVisibleMs, text]);
  return null;
}
